import events from "@/bl-events"
import { toggleAbtests } from "@/modules/abtest-toggle"

events.on("abtest:ready", () => {
  toggleAbtests()
  const body = document.querySelector("body")
  body.classList.remove("page-loading")
})
